var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSafeArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "styles_icon__C_hdQ",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 1.39932C16 1.04587 15.8596 0.706898 15.6097 0.45697C15.3597 0.207042 15.0208 0.0666347 14.6673 0.0666347L4.0058 0C3.65234 0 3.31337 0.140408 3.06344 0.390336C2.81351 0.640264 2.67311 0.979238 2.67311 1.33269C2.67311 1.68614 2.81351 2.02512 3.06344 2.27504C3.31337 2.52497 3.65234 2.66538 4.0058 2.66538H11.4155L0.394207 13.7134C0.269296 13.8373 0.170152 13.9847 0.102493 14.1471C0.0348345 14.3095 0 14.4837 0 14.6596C0 14.8355 0.0348345 15.0097 0.102493 15.1721C0.170152 15.3345 0.269296 15.4819 0.394207 15.6058C0.518098 15.7307 0.665495 15.8298 0.827895 15.8975C0.990296 15.9652 1.16449 16 1.34042 16C1.51635 16 1.69054 15.9652 1.85294 15.8975C2.01534 15.8298 2.16274 15.7307 2.28663 15.6058L13.3346 4.5578V11.9942C13.3346 12.3477 13.475 12.6866 13.725 12.9366C13.9749 13.1865 14.3139 13.3269 14.6673 13.3269C15.0208 13.3269 15.3597 13.1865 15.6097 12.9366C15.8596 12.6866 16 12.3477 16 11.9942V1.39932Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafeArrow);
export default __webpack_public_path__ + "static/media/safe-arrow.7513506d5d68ccb35ab268f7072e3901.svg";
export { ForwardRef as ReactComponent };